import { useState } from "react";
import { motion } from "framer-motion";
import { ChatCircleDots, ArrowRight, X } from "@phosphor-icons/react";

export function FollowUps({ questions, onSubmit, onSkip, onCancel }) {
  const [answers, setAnswers] = useState({});
  const [custom, setCustom] = useState({});
  const pick = (i, o) => setAnswers((a) => ({ ...a, [i]: a[i] === o ? undefined : o }));
  const value = (i) => (custom[i]?.trim() ? custom[i].trim() : answers[i]);
  const answered = questions.filter((_, i) => value(i)).length;

  const submit = () => {
    const lines = questions.map((q, i) => (value(i) ? `- ${q.q} ${value(i)}` : null)).filter(Boolean);
    onSubmit(lines.length ? `\n\nDetails:\n${lines.join("\n")}` : "");
  };

  return (
    <motion.div initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} className="stp-card mt-6 rounded-3xl p-6 sm:p-8" data-testid="followups-card">
      <div className="mb-5 flex items-start justify-between gap-3">
        <div className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-2xl bg-brand-soft text-brand"><ChatCircleDots size={20} weight="fill" /></span>
          <div>
            <p className="font-display text-xl font-semibold text-ink">A few quick questions</p>
            <p className="text-sm text-mist">Tap an answer so your prompt fits exactly what you need.</p>
          </div>
        </div>
        <button data-testid="followups-cancel-button" onClick={onCancel} className="text-mist hover:text-ink" aria-label="Close"><X size={18} /></button>
      </div>
      <div className="space-y-5">
        {questions.map((q, i) => (
          <div key={q.q} data-testid={`followup-question-${i}`}>
            <p className="mb-2 text-[15px] font-medium text-ink">{q.q}</p>
            <div className="flex flex-wrap gap-2">
              {q.options.map((o, j) => (
                <button key={o} data-testid={`followup-option-${i}-${j}`} onClick={() => pick(i, o)}
                  className={`rounded-full px-3.5 py-1.5 text-[13px] font-medium transition-colors ${answers[i] === o && !custom[i]?.trim() ? "bg-ink text-white" : "bg-black/5 text-ink hover:bg-black/10"}`}>
                  {o}
                </button>
              ))}
              <input data-testid={`followup-custom-${i}`} value={custom[i] || ""} onChange={(e) => setCustom((c) => ({ ...c, [i]: e.target.value }))} placeholder="Something else…"
                className="h-8 min-w-[140px] flex-1 rounded-full border border-black/10 bg-white px-3 text-[13px] text-ink outline-none focus:border-brand" />
            </div>
          </div>
        ))}
      </div>
      <div className="mt-7 flex flex-col-reverse items-stretch justify-end gap-2 sm:flex-row sm:items-center">
        <button data-testid="followups-skip-button" onClick={onSkip} className="h-11 rounded-full px-5 text-sm font-medium text-mist hover:text-ink">Skip, just write it</button>
        <button data-testid="followups-submit-button" onClick={submit} className="flex h-11 items-center justify-center gap-2 rounded-full bg-brand px-6 text-sm font-semibold text-white hover:bg-brand-hover">
          Create my prompt {answered > 0 && <span className="rounded-full bg-white/20 px-2 text-xs">{answered}/{questions.length}</span>} <ArrowRight size={15} weight="bold" />
        </button>
      </div>
    </motion.div>
  );
}
